import {FormControl, FormField, OptionType, Separator} from 'platform/components';
import {Grid, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {TestIdProps, suffixTestId} from 'shared/web';

import {MazdaClaimSendFormType} from '../types/MazdaClaimSendFormType';

interface MazdaClaimCampaignFieldsProps extends TestIdProps {
  control: FormControl<MazdaClaimSendFormType>;
  maintenanceOptions: OptionType[];
}

export function MazdaClaimCampaignFields(props: MazdaClaimCampaignFieldsProps) {
  return (
    <VStack spacing={4}>
      <Grid spacing={4} columns={2}>
        <FormField
          control={props.control}
          name="campaignNumber"
          type="text"
          label={i18n.t('entity.orderIntegration.labels.campaignNumber')}
          isDisabled
          data-testid={suffixTestId('campaignNumber', props)}
        />
        <FormField
          control={props.control}
          name="campaignVariantNumber"
          type="number"
          label={i18n.t('entity.orderIntegration.labels.campaignVariantNumber')}
          isDisabled
          data-testid={suffixTestId('campaignVariantNumber', props)}
        />
        <FormField
          control={props.control}
          name="mileage"
          type="number"
          label={i18n.t('entity.integration.labels.mileage')}
          suffix={i18n.t('general.metric.km')}
          isRequired
          data-testid={suffixTestId('mileage', props)}
        />
        <FormField
          control={props.control}
          name="repairDate"
          type="apiDate"
          label={i18n.t('entity.orderIntegration.labels.repairDate')}
          isRequired
          data-testid={suffixTestId('repairDate', props)}
        />
      </Grid>
      <FormField
        control={props.control}
        name="vehicleServicedAccordingToManufacturerSpecs"
        type="radio"
        label={i18n.t('entity.orderIntegration.labels.vehicleServicedAccordingToSpecs')}
        options={props.maintenanceOptions}
        isRequired
        data-testid={suffixTestId('vehicleServicedAccordingToSpecs', props)}
      />
      <Separator spacing={0} />
      <FormField
        control={props.control}
        name="causalPart"
        type="textarea"
        minRows={1}
        label={i18n.t('entity.orderIntegration.labels.causalPart')}
        isDisabled
        data-testid={suffixTestId('causalPart', props)}
      />
    </VStack>
  );
}
